import { render, staticRenderFns } from "./ProficiencyBadgeRemoved.vue?vue&type=template&id=dfb88142"
import script from "./ProficiencyBadgeRemoved.vue?vue&type=script&lang=js"
export * from "./ProficiencyBadgeRemoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports